import {React, classNames, withStyles, StyledProps, CentricTheme, _, Fragment, observer} from '@api'
import {Tooltip2} from '@api'
import {useStores} from '@modules'

import {PrimaryButton, PrimaryIconButton} from 'centric-ui-components'
import {Link, LinkOff} from '@material-ui/icons'
import {Typography, Button, Tooltip} from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  plmContainer: {
    position: 'relative',
    marginBottom: theme.spacing() * 2 + 4
  },
  text: {
    marginBottom: theme.spacing()
  },
  label: {
    fontSize: 14
  },
  textField: {
    fontSize: 14
  },
  textLabelFocus: {
    color: '#4184f3 !important'
  },
  newWindow: {
    width: theme.spacing() * 2 + 2,
    height: theme.spacing() * 2 + 2,
    position: 'absolute',
    top: theme.spacing() * 2 + 4,
    right: 0,
    color: 'rgba(0, 0, 0, 0.54)',
    cursor: 'pointer'
  },
  disabled: {
    color: 'rgba(27, 27, 27, 0.87)',
    '&:before': {
      borderBottom: '0 !important'
    }
  },
  textLabel: {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.38)'
  },
  shrink: {
    transform: 'translate(0, 1.5px) scale(0.8572)'
  },
  root: {
    marginBottom: theme.spacing() * 3
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: '-webkit-link',
    padding: '6px 0 7px'
  },
  linkSubtitle: {
    padding: '6px 0 7px'
  },
  linkIcon: {
    color: 'rgba(0, 0, 0, 0.38)'
  },
  linkContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  Icon: {
    height: '24px',
    width: '24px',
    color: 'var(--icon-grey-1)'
  },
  whiteIcon: {
    height: '24px',
    width: '24px'
  }
})

interface MyProps extends StyledProps {
  link?: string
  label?: string
  onClickPLMLink?: (e) => void
  onClickLinkToPLM?: (e) => void
  onClickLinkIcon?: (e) => void
  plmData?: any
}

const PLMLink = withStyles(styles as any)(observer<MyProps>(function PLMLink(props) {
  const {strings} = useStores(),
    {label, link, classes, onClickPLMLink, onClickLinkToPLM, onClickLinkIcon, plmData} = props,
    data: any = _.first(plmData && plmData.items)

  return (
    <div className={classes.plmContainer}>
      {
        !_.isEmpty(link) && !_.isEmpty(data)
        ? <Fragment>
          <Typography classes={{root: classes.textLabel}}>{`PLM Name`}</Typography>
          <div className={classes.linkContainer}>
            <Typography classes={{root: classes.link}} onClick={onClickPLMLink}>{data ? (data.name || '--') : ''}</Typography>
            <Tooltip2 content={strings.unLinkFromPLM}>
              <PrimaryIconButton
                className={classes.linkIcon}
                onClick={onClickLinkIcon}
                icon={<LinkOff classes={{root: classes.Icon}}/>}
              />
            </Tooltip2>
          </div>
          <Typography classes={{root: classes.textLabel}}>{`PLM Subtitle`}</Typography>
          <Typography classes={{root: classes.linkSubtitle}}>{data ? (data.description || '--') : ''}</Typography>
        </Fragment>
        : <PrimaryButton onClick={onClickLinkToPLM} icon={{position: 'left', component: <Link classes={{root: classes.whiteIcon}}/>}}>Link to PLM</PrimaryButton>
      }
    </div>
  )
}))


// WEBPACK FOOTER //
// ./src/shared/components/ui/components/PLMLink.tsx